import React from 'react'
import { reducer } from './utils'

import * as El from '../styles'

export default ({ field, form: { touched, errors }, ...props }) => {
  const title = reducer(props.form_s, field.name).title
  const error = reducer(errors, field.name)
  const touch = reducer(touched, field.name)

  return (
    <div>
      {title && <El.Title>{title}</El.Title>}
      <El.TextArea
        name={field.name}
        component='textarea'
        placeholder={props.placeholder}
        maxLength={255}
        error={error && touch}
      />
    </div>
  )
}
